import React from "react";

export const sanitizeText = (v: string) =>
  v.replaceAll("\t", " ").replaceAll(/\n+/g, " ").trim();

export function getCellText(cell: HTMLTableCellElement): string {
  const clone = cell.cloneNode(true) as HTMLElement;
  // Strip any UI controls or tooltips from the cloned content before reading text
  clone
    .querySelectorAll(
      '[data-copy-control], .copy-table-overlay, [role="tooltip"], [data-tooltip]'
    )
    .forEach((el) => el.remove());
  return sanitizeText(clone.textContent || "");
}

export function extractTableAsTsv(table: HTMLTableElement | null): string | null {
  if (!table) return null;
  const rows: string[] = [];
  Array.from(table.rows).forEach((row) => {
    const cells = Array.from(row.cells).map((c) =>
      getCellText(c)
    );
    rows.push(cells.join("\t"));
  });
  const tsv = rows.join("\n");
  return tsv.length > 0 ? tsv : null;
}

export function ensureCRLF(input: string): string {
  return input.replaceAll(/\r?\n/g, "\r\n");
}

export async function writeClipboardMulti(tsv: string, html?: string) {
  const plain = ensureCRLF(tsv);
  try {
    if (typeof ClipboardItem !== "undefined" && navigator.clipboard?.write) {
      const data: Record<string, Blob> = {
        "text/plain": new Blob([plain], { type: "text/plain" }),
      };
      if (html) data["text/html"] = new Blob([html], { type: "text/html" });
      await navigator.clipboard.write([new ClipboardItem(data)]);
    } else {
      await navigator.clipboard.writeText(plain);
    }
  } catch {
    await navigator.clipboard.writeText(plain);
  }
}

export function getScrollFadeMask(canScrollLeft: boolean, canScrollRight: boolean): React.CSSProperties | undefined {
  if (!canScrollLeft && !canScrollRight) return undefined;
  const left = canScrollLeft ? "transparent 0px, black 24px" : "black 0px";
  const right = canScrollRight ? "black calc(100% - 24px), transparent 100%" : "black 100%";
  const gradient = `linear-gradient(to right, ${left}, ${right})`;
  return { maskImage: gradient, WebkitMaskImage: gradient };
}
